// reactstrap components

import { Hidden } from "@material-ui/core";
import { Visibility } from "@material-ui/icons";

const Header = () => {
  return (
    <>
      <div className="header bg-gradient-info pb-8 pt-5 pt-md-8" style={{visibility: 'hidden'}}></div>
    </>
  );
};

export default Header;
